export const getSelectionText = (count: number, singular: string, plural: string, word: string): string => {
  return `${count} ${count === 1 ? singular : plural} ${word}${count === 1 ? '' : 's'}`;
};
